import './FlowsheetsList.css';
import {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom'
import FlowsheetsListTable from "../../components/FlowsheetsListTable/FlowsheetsListTable";
import { Container, Box, Typography, Paper, Button } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { getFlowsheetsList } from "../../services/flowsheetsList.service"; 
import NewFlowsheetDialog from "../../components/NewFlowsheetDialog/NewFlowsheetDialog";
import AIAssistantDialog from '../../components/AIAssistantDialog';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

// Development feature flag for Add Flowsheet button
const SHOW_ADD_FLOWSHEET_BUTTON = false; // Set to false to hide the button

export default function FlowsheetsList(props) {
  const {setNumberOfSubprocesses, theme} = props

  const [rows, setRows] = useState([]); 
  const [errorMessage, setErrorMessage] = useState(false); 
  const [ newFlowsheetError, setNewFlowsheetError] = useState(false)
  const [newFlowsheetDialogOpen, setNewFlowsheetDialogOpen] = useState(false);
  const [aiAssistantOpen, setAiAssistantOpen] = useState(false);
  let location = useLocation();
  
  useEffect(()=>{
      console.log("FlowsheetsList useEffect triggered");
      if(location.state) {
        setErrorMessage(true)
      }
      getFlowsheetsList()
      .then((data)=>{
          console.log("FlowsheetsList - received data:", data);
          console.log("FlowsheetsList - flowsheet_list:", data.flowsheet_list);
          setRows(data.flowsheet_list || []);
          setNumberOfSubprocesses({current: data.currentNumberOfSubprocesses, max: data.maxNumberOfSubprocesses});
      }).catch(e => {
        console.error("FlowsheetsList - error getting flowsheets list:", e);
        setRows([]); // Set empty array on error
    });
  }, []);

  const handleNewFlowsheetDialogClickOpen = () => {
    setNewFlowsheetDialogOpen(true);
  };

  const handleAiAssistantClick = () => {
    setAiAssistantOpen(true);
  };

  const handleReloadData = (shouldReload) => {
    setNewFlowsheetDialogOpen(false);
    if(shouldReload)
      console.log("reload table data....");
    else
      console.log("close....");
  };
  
  return ( 
    <Box 
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f8faff 0%, #e6edff 50%, #f0f4ff 100%)',
        padding: { xs: 1, sm: 2, md: 3 }
      }}
    >
      <Container  maxWidth="xl" sx={{ px: { xs: 1, sm: 2 } }}>
                 {/* Header Section */}
                 <Box sx={{ 
                   mb: { xs: 2, sm: 3, md: 4 },
                   display: 'flex',
                  
                   justifyContent: 'space-between',
                   alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'center' },
                   flexDirection: { xs: 'column', sm: 'column', md: 'row' },
                   gap: { xs: 2, sm: 2, md: 0 }
                 }}>
                   <Box sx={{ width: { xs: '100%', md: 'auto'  } }}>
                     <Typography
                       variant="h3"
                       component="h1"
                       sx={{
                         fontWeight: 700,
                         color: theme?.text?.primary || '#1F2937',
                         textAlign: { xs: 'center', sm: 'center', md: 'left' },
                         mb: 1,
                         background: `linear-gradient(135deg, ${theme?.button?.background || '#667eea'}, #764ba2)`,
                         backgroundClip: 'text',
                         WebkitBackgroundClip: 'text',
                         WebkitTextFillColor: 'transparent',
                         textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                         fontSize: { xs: '1.5rem', sm: '1.8rem', md: '2.2rem', lg: '2.5rem', xl: '3rem' },
                         lineHeight: 1.2
                       }}
                     >
                       Flowsheets
                     </Typography>
                     <Typography
                       variant="h6"
                       sx={{
                         color: theme?.text?.secondary || '#6B7280',
                         textAlign: { xs: 'center', sm: 'center', md: 'left' },
                         fontWeight: 400,
                         fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem', lg: '1.25rem' },
                         display: { xs: 'block', sm: 'block', md: 'block' },
                         lineHeight: 1.4,
                         maxWidth: { xs: '100%', md: '500px' }
                       }}
                     >
                       Select your water treatment flowsheet
                     </Typography>
                   </Box>
                   
                   {/* Action Buttons */}
                   <Box sx={{ 
                     display: 'flex', 
                     gap: { xs: 1, sm: 1.5, md: 2 },
                     alignItems: 'center',
                     justifyContent: { xs: 'center', sm: 'center', md: 'flex-end' },
                     width: { xs: '100%', md: 'auto' },
                     flexWrap: { xs: 'wrap', sm: 'nowrap' }
                   }}>
                     {/* Add Flowsheet Button - Conditionally rendered */}
                     {SHOW_ADD_FLOWSHEET_BUTTON && (
                       <Button
                         sx={{
                           background: `linear-gradient(135deg, ${theme?.button?.background || '#667eea'}, #764ba2)`,
                           color: theme?.button?.text || '#FFFFFF',
                           fontWeight: 600,
                           borderRadius: 2,
                           px: { xs: 2, sm: 2.5, md: 3 },
                           py: { xs: 1, sm: 1.25, md: 1.5 },
                           textTransform: 'none',
                           boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                           '&:hover': {
                             background: `linear-gradient(135deg, ${theme?.button?.hover || '#5a6fd8'}, #6a4c93)`,
                             boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
                             transform: 'translateY(-1px)'
                           },
                           fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                           minWidth: { xs: 'auto', sm: 'auto' },
                           whiteSpace: 'nowrap'
                         }}
                         onClick={handleNewFlowsheetDialogClickOpen}
                       >
                         <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                           New Flowsheet +
                         </Box>
                         <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                           New +
                         </Box>
                       </Button>
                     )}

                     {/* AI Assistant Button */}
                     <Button
                       sx={{
                         background: `linear-gradient(135deg, ${theme?.button?.background || '#667eea'}, #764ba2)`,
                         color: theme?.button?.text || '#FFFFFF',
                         fontWeight: 600,
                         borderRadius: 2,
                         px: { xs: 2, sm: 2.5, md: 3 },
                         py: { xs: 1, sm: 1.25, md: 1.5 },
                         textTransform: 'none',
                         boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                         '&:hover': {
                           background: `linear-gradient(135deg, ${theme?.button?.hover || '#5a6fd8'}, #6a4c93)`,
                           boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)',
                           transform: 'translateY(-1px)'
                         },
                         fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                         minWidth: { xs: 'auto', sm: 'auto' },
                         whiteSpace: 'nowrap'
                       }}
                       startIcon={<SmartToyIcon sx={{ fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' } }} />}
                       onClick={handleAiAssistantClick}
                     >
                       <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                         AI Assistant
                       </Box>
                       <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                         AI
                       </Box>
                     </Button>
                   </Box>
                 </Box>

        {/* Main Content Card */}
        <Paper 
          elevation={8}
          sx={{
            borderRadius: { xs: 1, sm: 2, md: 3 },
            overflow: 'hidden',
            background: theme?.card?.background || '#FFFFFF',
            border: `1px solid ${theme?.card?.border || '#E2E8F0'}`,
            boxShadow: theme?.card?.shadow || '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            mx: { xs: 0, sm: 0.5, md: 1 },
            width: '100%'
          }}
        >
          <FlowsheetsListTable 
            rows={rows} 
            handleNewFlowsheetDialogClickOpen={handleNewFlowsheetDialogClickOpen}
            theme={theme}
          />
        </Paper>
      
      <NewFlowsheetDialog 
        open={newFlowsheetDialogOpen} 
        onClose={handleReloadData}
        setNewFlowsheetError={setNewFlowsheetError}
      />
        
        {/* AI Assistant Dialog */}
        <AIAssistantDialog 
          open={aiAssistantOpen} 
          onClose={() => setAiAssistantOpen(false)} 
          flowsheetData={rows}
        />
        
      {location.state && 
      <Snackbar open={errorMessage} autoHideDuration={3000} onClose={() => setErrorMessage(false)}>
          <Alert 
            severity="error"
            sx={{
              borderRadius: 2,
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.15)'
            }}
          >
            Error building flowsheet
        </Alert>
      </Snackbar> 
      }
        
      {newFlowsheetError && 
      <Snackbar open={true} autoHideDuration={30000} onClose={() => setNewFlowsheetError(false)}>
          <Alert 
            severity="error"
            sx={{
              borderRadius: 2,
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.15)'
            }}
          >
          {newFlowsheetError}
        </Alert>
      </Snackbar> 
      }
    </Container>
    </Box>
  );

}


